export const IndexEquipment = () => {}
